import * as React from 'react';
import { useGetRoleAssignmentQuery } from "../../../apis/RoleAssignment.api";
import { PrimaryRoleAssignment, RoleAssignment } from "../../../types/models/RoleAssignment";
import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import RoleName from "../../../../auth/components/role/RoleDetail/RoleName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: RoleAssignment;
};

export const RoleAssignmentNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><MembersGroupName id={ data?.membersGroupId }/>
                    {data?.roleId && <> | </> }<RoleName id={ data?.roleId }/>
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const RoleAssignmentName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetRoleAssignmentQuery(PrimaryRoleAssignment.fromId(id))
    return (<RoleAssignmentNameDisplay data={data}/>)
}

export default RoleAssignmentName;
